// extracted by mini-css-extract-plugin
module.exports = {"preSale":"PreSale_preSale__1pU11"};